(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  function initRoot(panel) {
    if (!panel || panel.dataset.obReady === 'true') return;
    if (!panel.classList.contains('has-mobile-slider')) return;

    var track = panel.querySelector('.official-benefits__track');
    var prev = panel.querySelector('.official-benefits__arrow--prev');
    var next = panel.querySelector('.official-benefits__arrow--next');
    if (!track || !prev || !next) return;

    panel.dataset.obReady = 'true';

    function getItems() {
      return Array.prototype.slice.call(track.querySelectorAll('.official-benefits__item'));
    }

    function getCurrentIndex() {
      var items = getItems();
      if (!items.length) return 0;

      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var best = 0;
      var bestDist = Infinity;

      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(itemCenter - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function scrollToIndex(index) {
      var items = getItems();
      if (!items.length) return;

      var targetIndex = Math.max(0, Math.min(items.length - 1, index));
      var target = items[targetIndex];
      var left = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;

      track.scrollTo({
        left: Math.max(0, left),
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      if (!MQ.matches) {
        prev.classList.remove('is-disabled');
        next.classList.remove('is-disabled');
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
        prev.setAttribute('aria-disabled', 'false');
        next.setAttribute('aria-disabled', 'false');
        return;
      }

      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var left = track.scrollLeft;
      var atStart = left <= 2;
      var atEnd = left >= maxScroll - 2;

      prev.classList.toggle('is-disabled', atStart);
      next.classList.toggle('is-disabled', atEnd);
      prev.toggleAttribute('disabled', atStart);
      next.toggleAttribute('disabled', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function go(dir) {
      if (!MQ.matches) return;
      scrollToIndex(getCurrentIndex() + dir);
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.official-benefits__panel.has-mobile-slider').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('.official-benefits__panel.has-mobile-slider').forEach(function (panel) {
      panel.dataset.obReady = '';
      initRoot(panel);
    });
  });
})();
